<template>
  <div class="banner">
    <div class="banner-cont" style="position: relative">
      <img
        class="imge-banner"
        src="../../images/banner-bg.jpg"
        alt="Description of image"
        style="
          object-fit: cover;
          width: 100%;
          height: 100%;
          margin-bottom: -10px;
        "
      />
      <div
        class="content"
        style="position: absolute; top: 0; padding: 0 15px; width: 50%"
      >
        <h3>
          Welcome to our global website.
          <span class="name-web">Hot spot plus</span> There are all
          international and local products
        </h3>
        <span class="text-con">
          Discounts on all international products
          <span class="dis">35%</span>
        </span>
        <v-btn
          class="btn-banner"
          variant="outlined"
          color="white"
          style="border-radius: 30px; width: fit-content; margin: 20px auto"
          >Shop now</v-btn
        >
      </div>
    </div>
  </div>
</template>
<style lang="css">
@media (max-width: 990px) {
  .banner img {
    margin-top: 35px;
  }
  .banner .content {
    margin-top: -25px;
    text-align: center;
    font-size: 13px;
  }
  .banner .banner-cont .content h3 {
    font-size: 14px;
  }
}
@media (max-width: 767px) {
  .banner img {
    margin-top: 48px;
  }
  .banner .banner-cont .content {
  }

  .banner .banner-cont .content h3 {
  }
  .banner .banner-cont .content .text-con {
  }
  .banner .banner-cont .content .text-con .dis {
  }
  .banner .banner-cont .content .btn-banner {
    display: none;
  }
}
@media (max-width: 480px) {
  .banner .banner-cont .content {
  }
  .banner .imge-banner {
    height: 126px;
    margin-bottom: -6px;
  }

  .banner .banner-cont .content h3 {
    font-size: 11px;
    margin-top: 96px !important;
  }
  .banner .banner-cont .content .text-con {
    display: none;
  }
  .banner .banner-cont .content .text-con .dis {
    font-size: 13px;
  }
  .banner .banner-cont .content .btn-banner {
    display: none;
  }
}
.banner .banner-cont .content h3 {
  margin-top: 100px;
  color: white;
}
.banner .banner-cont .content h3 span {
  color: #21b7f3;
  text-transform: capitalize;
  display: inline;
}
.banner .banner-cont .content span {
  display: block;
  color: #21b7f3;
  margin-top: 5px;
  font-weight: 800;
}
.banner .banner-cont .content span .dis {
  color: #ffeb3b;
  display: inline;
  font-size: 18px;
  font-weight: bold;
}
</style>

<script setup></script>
